import type { GetAttachmentsResponseType } from "@nlc/shared-types";

import { useQuery } from "@tanstack/react-query";

import { attachmentsKeys } from "@/hooks/queryKeys.ts";
import { useIsTemplate } from "@/hooks/useIsTemplate.tsx";
import { useRequestId } from "@/hooks/useRequestId.tsx";
import apiClient from "@/lib/api/client.ts";

export function useGetAttachments() {
  const requestId = useRequestId();
  const { isTemplate } = useIsTemplate();

  return useQuery<GetAttachmentsResponseType>({
    enabled: !!requestId || isTemplate,
    queryFn: async () => {
      if (isTemplate) return [];

      return apiClient.url(`/attachments/${requestId}`).get().json();
    },
    queryKey: attachmentsKeys.attachmentsByRequestId(Number(requestId)),
  });
}
